export default () => {
  const $postTabs = $('.post-tabs');

  if ($postTabs.length === 0) {
    return;
  }

  const $postTabsMobileBtn = $postTabs.find('.post-tabs-nav__mobile');
  $postTabsMobileBtn.text($postTabs.find('.post-tabs-nav__item.is-active .post-tabs-nav__btn').text());

  $postTabs.on('click', '.post-tabs-nav__btn', (e) => {
    e.preventDefault();
    const $currentTarget = $(e.currentTarget);
    const $parent = $currentTarget.parent();

    if ($parent.hasClass('is-active')) {
      return;
    }

    const index = $parent.index();

    $postTabs.find('.post-tabs-nav__item.is-active').removeClass('is-active');
    $parent.addClass('is-active');

    $postTabs.find('.post-tabs__item.is-active').removeClass('is-active');
    $postTabs.find(`.post-tabs__item:eq(${index})`).addClass('is-active');

    $postTabsMobileBtn.text($currentTarget.text());
    $postTabs.removeClass('is-active');
  });

  $postTabs.on('click', '.post-tabs-nav__mobile', (e) => {
    e.preventDefault();
    $postTabs.toggleClass('is-active');
  });
};
